var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C7.46957 3 6.96086 3.21071 6.58579 3.58579C6.21071 3.96086 6 4.46957 6 5C6 5.53043 6.21071 6.03914 6.58579 6.41421C6.96086 6.78929 7.46957 7 8 7C8.53043 7 9.03914 6.78929 9.41421 6.41421C9.78929 6.03914 10 5.53043 10 5C10 4.46957 9.78929 3.96086 9.41421 3.58579C9.03914 3.21071 8.53043 3 8 3ZM8 8.33333C7.11594 8.33333 6.2681 7.98214 5.64298 7.35702C5.01786 6.7319 4.66667 5.88406 4.66667 5C4.66667 4.11595 5.01786 3.2681 5.64298 2.64298C6.2681 2.01786 7.11594 1.66667 8 1.66667C8.88405 1.66667 9.7319 2.01786 10.357 2.64298C10.9821 3.2681 11.3333 4.11595 11.3333 5C11.3333 5.88406 10.9821 6.7319 10.357 7.35702C9.7319 7.98214 8.88405 8.33333 8 8.33333ZM8 0C4.66667 0 1.82 2.07333 0.666666 5C1.82 7.92667 4.66667 10 8 10C11.3333 10 14.18 7.92667 15.3333 5C14.18 2.07333 11.3333 0 8 0Z",
    fill: "#141B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.bba565eac47be0299f2230368e5fac9e.svg";
export { ForwardRef as ReactComponent };